<script>
    import { fade } from 'svelte/transition';
    import { onMount } from 'svelte';
    import { clickoutside } from '@svelte-put/clickoutside';
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { projectState } from "@app/store/projectStore.svelte.js";
    import ContextMenuCut from './ContextMenuCut.svelte';
    import ContextMenuCopy from './ContextMenuCopy.svelte';
    import ContextMenuCopyText from './ContextMenuCopyText.svelte';
    import ContextMenuPaste from './ContextMenuPaste.svelte';
    import ContextMenuDelete from './ContextMenuDelete.svelte';
    import ContextMenuAutoFormat from './ContextMenuAutoFormat.svelte';
    import ContextMenuAutoTime from './ContextMenuAutoTime.svelte';
    import ContextMenuAutoTimeByAudioDuration from './ContextMenuAutoTimeByAudioDuration.svelte'; 
    import ContextMenuCleanText from './ContextMenuCleanText.svelte';
    import ContextMenuClearSpeakers from './ContextMenuClearSpeakers.svelte';
    import ContextMenuMerge from './ContextMenuMerge.svelte';
    import ContextMenuApprove from './ContextMenuApprove.svelte';
    import ContextMenuForcedSubtitle from './ContextMenuForcedSubtitle.svelte';
    import ContextMenuSelectAll from './ContextMenuSelectAll.svelte';
    import ContextMenuSelectAllBefore from './ContextMenuSelectAllBefore.svelte';
    import ContextMenuSelectAllAfter from './ContextMenuSelectAllAfter.svelte';
    import ContextMenuEventTemplate from './ContextMenuEventTemplate.svelte';
    import ContextMenuPasteAttributes from './ContextMenuPasteAttributes.svelte';
    import MenuDivider from './MenuDivider.svelte';
    import * as m from "@app/paraglide/messages.js";

    /** @type {{x: any, y: any, showContextMenu?: boolean}} */
    let { x, y = $bindable(), showContextMenu = $bindable(false) } = $props();

    let contextMenuHeight;

    onMount(async () => {
        //get the screen height and the context menu height to see if the context menu is going past the screen height
        contextMenuHeight = parseInt(document.getElementById("EditorContextMenu").offsetHeight);
    });

    function calculateYPosition() {
        if (contextMenuHeight === undefined) {
            return;
        }
        
        let screenHeight = parseInt(window.innerHeight);
        //if the context menu is going past the screen height, then adjust the y position
        if (parseInt(y) + contextMenuHeight > screenHeight) {
            y = screenHeight - contextMenuHeight;        
        }
    }

    function closeContextMenu(){
        showContextMenu = false;
    }

    // Replace run with $effect for calculating y position
    $effect(() => {
        // console.log("EFFECT Calculating Y Position for Context Menu...");
        calculateYPosition(y);
    });
</script>

<div id="EditorContextMenu"
     class="dropdown-menu"
     role="menu"
     aria-labelledby="ContextMenuHeading"
     transition:fade={{ duration: 250 }}
     style="top: {y}px; left: {x}px;"
     use:clickoutside onclickoutside={closeContextMenu}>
    <h6 id="ContextMenuHeading" class="dropdown-header">{m.context_menu_title()}</h6>
    <ContextMenuCut on:done={closeContextMenu}></ContextMenuCut>
    <ContextMenuCopy on:done={closeContextMenu}></ContextMenuCopy>
    <ContextMenuCopyText on:done={closeContextMenu}></ContextMenuCopyText>
    <ContextMenuPaste on:done={closeContextMenu}></ContextMenuPaste>
    <ContextMenuPasteAttributes on:done={closeContextMenu}></ContextMenuPasteAttributes>
    <!-- Divider -->
    <MenuDivider></MenuDivider>
    <ContextMenuDelete on:done={closeContextMenu}></ContextMenuDelete>
    <!-- Divider -->
    <MenuDivider></MenuDivider>
    <ContextMenuSelectAllBefore on:done={closeContextMenu}></ContextMenuSelectAllBefore>
    <ContextMenuSelectAll on:done={closeContextMenu}></ContextMenuSelectAll>    
    <ContextMenuSelectAllAfter on:done={closeContextMenu}></ContextMenuSelectAllAfter>
    <!-- Divider -->
    <MenuDivider></MenuDivider>
    
    <ContextMenuAutoFormat on:done={closeContextMenu}></ContextMenuAutoFormat>
    <ContextMenuCleanText on:done={closeContextMenu}></ContextMenuCleanText>
    <ContextMenuClearSpeakers on:done={closeContextMenu}></ContextMenuClearSpeakers>
    <ContextMenuAutoTime on:done={closeContextMenu}></ContextMenuAutoTime>

    {#if eventGroupState[projectState.selected] && eventGroupState[projectState.selected].type === "audio description"}
        <ContextMenuAutoTimeByAudioDuration on:done={closeContextMenu}></ContextMenuAutoTimeByAudioDuration>
    {/if}
    <ContextMenuMerge on:done={closeContextMenu}></ContextMenuMerge>    
    <MenuDivider></MenuDivider>
    <ContextMenuForcedSubtitle on:done={closeContextMenu}></ContextMenuForcedSubtitle>
    <ContextMenuApprove on:done={closeContextMenu}></ContextMenuApprove>
    <!-- Divider -->
    <MenuDivider></MenuDivider>
    <ContextMenuEventTemplate on:done={closeContextMenu}></ContextMenuEventTemplate>
</div>

<style lang="css">
#EditorContextMenu {
    position: fixed;
    display: grid;
    max-width: 340px;
    z-index: 1059;
}
</style>
